module.exports = __webpack_public_path__ + "caa952957dbbe8e440810fe89971ffd4.pdf";